import React, { useState } from "react";
import { db } from "../../../firebaseConfig";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import classes from "./CRPage.module.css";

export default function AddCR() {
    const [rollNumber, setRollNumber] = useState("");
    const [crName, setCrName] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [rollError, setRollError] = useState("");
    const [studentExists, setStudentExists] = useState(false);

    // Check if student exists in "students" table
    const checkStudentExists = async (enteredRoll) => {
        setRollError("");
        setStudentExists(false);

        if (!enteredRoll.trim()) return;

        try {
            const q = query(
                collection(db, "students"),
                where("stdRegNumber", "==", enteredRoll.trim())
            );
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                setRollError("This student doesn’t exist in Students table. Please add this student first.");
                setStudentExists(false);
            } else {
                setRollError("");
                setStudentExists(true);
            }
        } catch (error) {
            console.error("Error checking student:", error);
        }
    };

    const handleAddCR = async (e) => {
        e.preventDefault();
        setMessage("");

        if (!rollNumber.trim() || !crName.trim()) {
            setMessage("Please fill in all fields.");
            return;
        }

        if (!studentExists) {
            setRollError("This student doesn’t exist in Students table. Please add this student first.");
            return;
        }

        setLoading(true);
        try {
            await addDoc(collection(db, "CR"), {
                rollNumber: rollNumber.trim(),
                name: crName.trim(),
                createdAt: new Date()
            });
            setMessage("CR added successfully!");
            setRollNumber("");
            setCrName("");
            setStudentExists(false);
        } catch (error) {
            console.error("Error adding CR:", error);
            setMessage("Error adding CR.");
        }
        setLoading(false);
    };

    return (
        <div className={classes.container}>
            <h2 className={classes.title}>Add Class Representative</h2>
            <form onSubmit={handleAddCR} className={classes.form}>
                <input
                    type="text"
                    placeholder="CR Roll Number"
                    value={rollNumber}
                    onChange={(e) => setRollNumber(e.target.value)}
                    onBlur={() => checkStudentExists(rollNumber)}
                    className={classes.input}
                />
                {rollError && <p style={{ color: "red", fontSize: "0.9em" }}>{rollError}</p>}

                <input
                    type="text"
                    placeholder="CR Name"
                    value={crName}
                    onChange={(e) => setCrName(e.target.value)}
                    className={classes.input}
                />
                <button type="submit" className={classes.button} disabled={loading}>
                    {loading ? "Adding..." : "Add CR"}
                </button>
                {message && <p className={classes.message}>{message}</p>}
            </form>
        </div>
    );
}
